'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactDndTouchBackend = require('react-dnd-touch-backend');

var _reactDndTouchBackend2 = _interopRequireDefault(_reactDndTouchBackend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Backend = {
  HTML5: 0,
  TOUCH: 1,
  MAX: 2
};

var MultiBackend = function () {
  function MultiBackend(manager, sourceOptions) {
    _classCallCheck(this, MultiBackend);

    var options = Object.assign({ start: Backend.HTML5 }, sourceOptions || {});

    this.current = options.start;

    this.backends = [];
    this.backends[Backend.HTML5] = new _reactDndHtml5Backend2.default(manager);
    this.backends[Backend.TOUCH] = new _reactDndTouchBackend2.default({ enableMouseEvents: true })(manager);

    this.nodes = {};

    var funcs = ['setup', 'teardown', 'connectDragSource', 'connectDragPreview', 'connectDropTarget', 'previewEnabled', 'addEventListeners', 'removeEventListeners', 'backendSwitcher', 'cleanUpHandlers', 'applyToBackend', 'callBackends', 'restrictTouchBackend', 'freeTouchBackend'];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = funcs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var func = _step.value;

        this[func] = this[func].bind(this);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  // DnD Backend API


  _createClass(MultiBackend, [{
    key: 'setup',
    value: function setup() {
      if (typeof window === 'undefined') {
        return;
      }

      if (this.constructor.isSetUp) {
        throw new Error('Cannot have two Multi backends at the same time.');
      }
      this.constructor.isSetUp = true;
      this.addEventListeners(window);
      this.backends[this.current].setup();
    }
  }, {
    key: 'teardown',
    value: function teardown() {
      if (typeof window === 'undefined') {
        return;
      }

      this.constructor.isSetUp = false;
      this.removeEventListeners(window);
      this.backends[this.current].teardown();
    }
  }, {
    key: 'connectDragSource',
    value: function connectDragSource() {
      return this.callBackends('connectDragSource', arguments);
    }
  }, {
    key: 'connectDragPreview',
    value: function connectDragPreview() {
      return this.callBackends('connectDragPreview', arguments);
    }
  }, {
    key: 'connectDropTarget',
    value: function connectDropTarget() {
      return this.callBackends('connectDropTarget', arguments);
    }

    // Use by Preview component

  }, {
    key: 'previewEnabled',
    value: function previewEnabled() {
      return this.current === Backend.TOUCH;
    }

    // Multi Backend Listeners

  }, {
    key: 'addEventListeners',
    value: function addEventListeners(target) {
      target.addEventListener('touchstart', this.backendSwitcher, true);
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners(target) {
      target.removeEventListener('touchstart', this.backendSwitcher, true);
    }

    // Switching logic

  }, {
    key: 'backendSwitcher',
    value: function backendSwitcher(event) {
      var oldBackend = this.current;

      if (this.current === Backend.HTML5 && event.touches != null) {
        this.current = Backend.TOUCH;
        this.removeEventListeners(window);
      }

      if (this.current !== oldBackend) {
        this.backends[oldBackend].teardown();
        this.cleanUpHandlers(oldBackend);
        this.backends[this.current].setup();

        if (this.current === Backend.TOUCH) {
          this.freeTouchBackend();
          this.backends[this.current].handleTopMoveStartCapture(event);
          this.backends[this.current].getTopMoveStartHandler()(event);
        }
      }
    }
  }, {
    key: 'cleanUpHandlers',
    value: function cleanUpHandlers(backend) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(this.nodes)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var id = _step2.value;

          var node = this.nodes[id];
          node.handlers[backend]();
          node.handlers[backend] = null;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    // Which backend should be called

  }, {
    key: 'applyToBackend',
    value: function applyToBackend(backend, func, args) {
      var self = this.backends[backend];
      return self[func].apply(self, args);
    }
  }, {
    key: 'callBackends',
    value: function callBackends(func, args) {
      var handlers = [];
      var nodeId = func + '_' + args[0];

      for (var i = 0; i < Backend.MAX; ++i) {
        if (i < this.current) {
          handlers.push(null);
          continue;
        }

        var touchAndNotCurrent = i == Backend.TOUCH && i != this.current;
        if (touchAndNotCurrent) {
          this.restrictTouchBackend(true);
        }
        handlers.push(this.applyToBackend(i, func, args));
        if (touchAndNotCurrent) {
          this.restrictTouchBackend(false);
        }
      }

      var nodes = this.nodes;
      nodes[nodeId] = { func: func, args: args, handlers: handlers };

      return function () {
        delete nodes[nodeId];
        for (var _i = 0; _i < handlers.length; ++_i) {
          var handler = handlers[_i];
          if (handler) {
            handler(arguments);
          }
        }
      };
    }

    // Special cases for TouchBackend

  }, {
    key: 'restrictTouchBackend',
    value: function restrictTouchBackend(enable) {
      this.backends[Backend.TOUCH].listenerTypes = enable ? ['touch'] : ['touch', 'mouse'];
    }
  }, {
    key: 'freeTouchBackend',
    value: function freeTouchBackend() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = Object.keys(this.nodes)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var id = _step3.value;

          var node = this.nodes[id];
          node.handlers[Backend.TOUCH]();
          node.handlers[Backend.TOUCH] = this.applyToBackend(Backend.TOUCH, node.func, node.args);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }]);

  return MultiBackend;
}();

MultiBackend.Backend = Backend;

exports.default = MultiBackend;


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-multi-backend/lib/MultiBackend.js
// module id = 1314
// module chunks = 0